export default __webpack_public_path__ + "static/media/certificate.7efa6009.jpg";